import { render } from "./PictureEnclosure.vue?vue&type=template&id=7947f2bf"
import script from "./PictureEnclosure.vue?vue&type=script&lang=js"
export * from "./PictureEnclosure.vue?vue&type=script&lang=js"
script.render = render

export default script